<template>
  <div class="safe-right">
    <div class="login-pwd">
      <div>
        <img src="@/assets/img/icon/u3171.png" alt="" />
        登录密码
      </div>
      <div>
        <div>
          <img src="@/assets/img/icon/u396.png" alt="" />
          <span class="left-font">已设置</span>
          <span class="center-line"></span>
          <span class="right-font" style="cursor: pointer;" @click="showChangePwd">修改密码 >></span>
        </div>
      </div>
      <div class="safe-color">
        安全性较高的密码可以使账号更安全，建议你定期更换密码。
      </div>
    </div>
    <div class="sms-code">
      <div>
        <img src="@/assets/img/icon/u3167.png" alt="" />
        手机短信验证
      </div>
      <div>
        <div style="overflow:visible">
          <img src="@/assets/img/icon/u398.png" alt="" v-if="!showPhoneVerify" />
          <span class="left-font" v-if="!showPhoneVerify" style="color:rgb(161, 161, 161)">未开启</span>
          <img src="@/assets/img/icon/u396.png" alt="" v-if="showPhoneVerify" />
          <span class="left-font" v-if="showPhoneVerify">已开启</span>
          <span class="center-line"></span>
          <span class="right-font" v-if="!showPhoneVerify" style="cursor: pointer;" @click="showSmsCode">开启验证 >></span>
          <span class="right-font" v-if="showPhoneVerify" style="cursor: pointer;" @click="showSmsCode">关闭验证 >></span>
          <!-- <span
            class="right-font"
            @click="closeSms = !closeSms"
          >不可关闭?
            <div class="close-sms">
              <p>为什么不可关闭手机短信验证？</p>
              <p>
                为提升账号安全性，防止恶意登录，我们开启了所有用户的手机短信验证。
              </p>
              <p>
                你如果感觉手机短信验证麻烦，请使用维护大师APP扫码登录。无需绑定，<span>将维护大师APP更新到最新版本，使用如图所指示的扫一扫功能</span>，扫描二维码，就可安全快捷地完成登录。
              </p>
              <p>
                <img
                  src="@/assets/img/icon/u150.png"
                  alt=""
                />
              </p>
              <p>黄圈所示为扫一扫功能</p>
              <span></span>
              <span></span>
            </div>
          </span> -->
        </div>
      </div>
      <div class="safe-color">
        已绑定手机号
        <span v-text="form.phone" style="color:rgb(82, 153, 214)"></span>
        <span v-show="form.passportType == 0">
          ，手机号不正确你可以
          <span style="cursor: pointer;" @click="showPhoneBind" class="span-color">
            修改绑定手机
          </span>
        </span>
        。
      </div>
    </div>
    <div class="wx">
      <div>
        <img src="@/assets/img/icon/u3169.png" alt="" />
        微信绑定
      </div>
      <div>
        <div>
          <img src="@/assets/img/icon/u398.png" alt="" v-show="!showBindWX" />
          <span class="left-font" v-show="!showBindWX" style="color:rgb(161, 161, 161)">未授权</span>
          <img src="@/assets/img/icon/u396.png" alt="" v-show="showBindWX" />
          <span class="left-font" v-show="showBindWX">已授权</span>
          <span class="center-line"></span>
          <span class="right-font" v-show="showBindWX" style="cursor: pointer;" @click="showWxUntied">解除绑定 >></span>
          <span class="right-font" v-show="!showBindWX" style="cursor: pointer;" @click="showWxBind">前去绑定 >></span>
        </div>
      </div>
      <div>
        <span v-show="showBindWX">已授权绑定微信</span><span v-show="!showBindWX"
          style="color:rgb(161, 161, 161)">未授权绑定微信</span>
      </div>
    </div>
    <div class="wx">
      <div>
        <img src="@/assets/img/icon/sao.png" alt="" />
        维护大师APP扫码登录
      </div>
      <div>
        <div>
          <img src="@/assets/img/icon/u396.png" alt="" />
          <span class="left-font">已授权</span>
        </div>
      </div>
      <div>
        <span class="safe-color">将维护大师APP更新至最新版本，即可在登录维护大师时扫码登录。</span>
      </div>
    </div>
    <!-- 修改密码 -->
    <fade-down-modal :show="showPwd">
      <div style="width:600px;background:#fff;margin:0 auto;">
        <change-pwd @showPwd="showPwd = false"></change-pwd>
      </div>
    </fade-down-modal>
    <!-- 变更短信 -->
    <fade-down-modal :show="showSms">
      <div style="width:600px;height:290px;background:#fff;margin:0 auto;">
        <change-sms @showSms="showSms = false" :state="showPhoneVerify"></change-sms>
      </div>
    </fade-down-modal>
    <!-- 绑定微信 -->
    <fade-down-modal :show="showWx">
      <div style="width:600px;background:#fff;margin:0 auto;">
        <change-wx @showWx="showWx = false"></change-wx>
      </div>
    </fade-down-modal>
    <!-- 微信解绑 -->
    <fade-down-modal :show="showUntied">
      <div style="width:600px;background:#fff;margin:0 auto;">
        <change-untied @showUntied="showUntied = false"></change-untied>
      </div>
    </fade-down-modal>
    <!-- 修改绑定手机 -->
    <fade-down-modal :show="showPhone" style="z-index:999">
      <div style="width:600px;background:#fff;margin:0 auto;">
        <change-phone @showPhone="phone"></change-phone>
      </div>
    </fade-down-modal>
  </div>
</template>
<script>
import FadeDownModal from "_c/modals/fadeDown";
import ChangePwd from "./modals/changePwd";
import ChangeSms from "./modals/changeSms";
import ChangeWx from "./modals/changeWx";
import ChangeUntied from "./modals/changeUntied";
import ChangePhone from "./modals/changePhone";
import { mapState } from "vuex";
export default {
  name: "safeRight",
  components: {
    FadeDownModal,
    ChangePwd,
    ChangeSms,
    ChangeWx,
    ChangeUntied,
    ChangePhone
  },
  data () {
    return {
      showPwd: false, //修改密码弹框
      showSms: false, //变更短信弹框
      showWx: false, //绑定微信弹框
      showUntied: false, //微信解绑弹框
      showPhone: false, //修改绑定手机弹框
      //showBindWX: '',             //微信绑定状态
      showPhoneVerify: "", //手机验证状态
      codeModel: false,
      closeSms: false
    };
  },
  computed: {
    ...mapState({
      form: state => state.user.userInfo,
      showBindWX: state => state.user.userInfo.wxBind
    })
  },
  methods: {
    //显示修改密码弹框
    showChangePwd () {
      this.showPwd = true;
      // this.$msg({
      //     message:'你真厉害',
      //     type:'success',
      //     showClose:true
      // })
    },
    //显示变更短信弹框
    showSmsCode () {
      this.showSms = true;
    },
    // 显示微信绑定弹框
    showWxBind () {
      this.showWx = true;
    },
    // 显示微信解绑弹框
    showWxUntied () {
      this.showUntied = true;
    },
    // 显示手机绑定弹框
    showPhoneBind () {
      this.showPhone = true;
    },
    phone (data) {
      this.showPhone = data;
    },
    phoneTpype () {
      if (this.form.saveType == 1)
      {
        this.showPhoneVerify = true;
      } else
      {
        this.showPhoneVerify = false;
      }
    },
    bindWx () {
      if (this.form.wxBind == true)
      {
        this.showBindWx = true;
      } else
      {
        this.showBindWx = false;
      }
    }
  },
  mounted () {
    this.phoneTpype();
    console.log(this.state)
  },
  updated () {
    this.phoneTpype();
  }
};
</script>
<style lang="scss" scoped>
.safe-right {
  margin-top: 20px;
  width: 60%;

  .login-pwd,
  .sms-code,
  .wx {
    width: 100%;
    min-width: 650px;
    margin-bottom: 53px;
    padding-top: 20px;
    padding-left: 20px;
    border-top: 2px dashed rgb(230, 230, 230);

    div {
      width: 90%;
      text-align: left;
      font-size: 14px;

      img {
        float: left;
        margin-right: 10px;
        margin-top: 3px;
      }

      div {
        // overflow: hidden;
        margin-left: 400px;
        width: 280px;
        float: left;

        img {
          margin-top: 5px;
        }

        .left-font {
          float: left;
          color: rgb(0, 153, 0);
        }

        .center-line {
          float: left;
          display: block;
          margin: 0 15px;
          width: 1px;
          height: 20px;
          background-color: rgb(230, 230, 230);
        }

        .right-font {
          float: left;
          color: rgb(0, 102, 204);
          overflow: hidden;
        }
      }
    }

    div:nth-child(3) {
      float: left;
      padding-left: 20px;
      font-size: 12px;

      .span-color {
        color: rgb(0, 102, 204);
      }
    }
  }
}

.header {
  padding-left: 30px;
  text-align: left;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #d9dee4;
}

.footer {
  margin-top: 20px;
  padding: 20px 0;
  margin-left: 5%;
  width: 90%;
  text-align: right;
  border-top: 1px solid #d9dee4;

  button {
    width: 100px;
    line-height: 30px;
  }

  button:nth-child(1) {
    background-color: rgb(0, 153, 204);
    border: 1px solid rgb(0, 153, 204);
    color: #fff;
  }

  button:nth-child(2) {
    margin-left: 10px;
    background-color: rgb(247, 247, 247);
    border: 1px solid #d9dee4;
  }
}

.right-font:hover .close-sms {
  // transition: all .5s;
  // opacity: 1;
  display: block;
  // transform: translate(-430px,20px);
}

.close-sms {
  // opacity: 0;
  display: none;
  // transition: all .5s;
  overflow: visible;
  position: absolute;
  transform: translate(-410px, 20px);
  width: 300px;
  padding: 10px 15px;
  background: rgb(245, 245, 245);
  box-shadow: 1px 2px 5px rgb(216, 216, 216);
  border: 1px solid rgb(215, 215, 215);
  border-radius: 3px;

  p {
    margin-bottom: 20px;
    font-size: 12px;
    color: #000;

    span {
      color: rgb(0, 153, 204);
    }

    img {
      width: 100%;
      margin-bottom: 10px;
    }
  }

  p:first-child {
    font-size: 14px;
  }

  p:nth-child(5) {
    padding-top: 0px;
    margin-bottom: 10px;
    color: rgb(180, 169, 180);
    text-align: right;
  }

  span:nth-child(6) {
    display: block;
    position: absolute;
    // left: -7px;
    top: -7px;
    width: 12px;
    height: 12px;
    border: 1px solid rgb(215, 215, 215);
    background: rgb(245, 245, 245);
    transform: rotateZ(-45deg);
    box-shadow: 1px 2px 5px rgb(216, 216, 216);
  }

  span:nth-child(7) {
    display: block;
    position: absolute;
    left: 10px;
    top: 0.5px;
    width: 24px;
    height: 14px;
    background: rgb(245, 245, 245);
  }
}

.safe-color {
  color: rgb(160, 160, 160);
}
</style>
